import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import { Command as CommandPrimitive } from 'cmdk';
import type { ComponentPropsWithoutRef } from 'react';
import { forwardRef } from 'react';
type CommandItemProps = ComponentPropsWithoutRef<typeof CommandPrimitive.Item> & {
  size?: 'compact' | 'default';
  disabled?: boolean;
  keywords?: string[];
};
const CommandItem = forwardRef<HTMLDivElement, CommandItemProps>((t0, ref) => {
  const $ = _c(16);
  let className;
  let disabled;
  let keywords;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      disabled,
      keywords,
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = disabled;
    $[3] = keywords;
    $[4] = props;
    $[5] = t1;
  } else {
    className = $[1];
    disabled = $[2];
    keywords = $[3];
    props = $[4];
    t1 = $[5];
  }
  const size = t1 === undefined ? "default" : t1;
  let t2;
  if ($[6] !== className || $[7] !== disabled || $[8] !== size) {
    t2 = cx("flex justify-between cursor-pointer rounded", "data-[selected=true]:bg-(--dropdown-hover-bg) data-[selected=false]:hover:bg-(--dropdown-hover-bg)", {
      "text-quaternary bg-secondary pointer-events-none": disabled
    }, {
      "py-1.5 px-3": size === "default",
      "py-1.5 px-2": size === "compact"
    }, className);
    $[6] = className;
    $[7] = disabled;
    $[8] = size;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== disabled || $[11] !== keywords || $[12] !== props || $[13] !== ref || $[14] !== t2) {
    t3 = <CommandPrimitive.Item ref={ref} keywords={keywords} className={t2} data-disabled={disabled} {...props} />;
    $[10] = disabled;
    $[11] = keywords;
    $[12] = props;
    $[13] = ref;
    $[14] = t2;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  return t3;
});
export default CommandItem;